import {
  IAthenaPostingListParams,
  IAthenaPostingListResponse,
  IAthenaPostingRetryResponse,
  IAthenaPostingStatusReport,
} from "types/AthenaIntegration";

import { api } from ".";

// CLE-2948 — Athena payment postings (Integrations → Athena). SuperAdmin only. The API never returns
// a posting's raw Athena response.
const athenaPostingQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAthenaPostingStatus: builder.query<IAthenaPostingStatusReport, void>({
      query: () => ({ url: "/athena/status", method: "GET" }),
      providesTags: [{ type: "AthenaPostings", id: "STATUS" }],
    }),
    getAthenaPostings: builder.query<
      IAthenaPostingListResponse,
      IAthenaPostingListParams
    >({
      query: ({ accountId, status, page, pageSize }) => ({
        url: "/athena/postings",
        method: "GET",
        params: {
          ...(accountId ? { accountId } : {}),
          ...(status ? { status } : {}),
          page,
          pageSize,
        },
      }),
      providesTags: [{ type: "AthenaPostings", id: "LIST" }],
    }),
    retryAthenaPosting: builder.mutation<IAthenaPostingRetryResponse, string>({
      query: (postingId) => ({
        url: `/athena/postings/${postingId}/retry`,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "AthenaPostings", id: "LIST" },
        { type: "AthenaPostings", id: "STATUS" },
      ],
    }),
  }),
});

export const {
  useGetAthenaPostingStatusQuery,
  useGetAthenaPostingsQuery,
  useRetryAthenaPostingMutation,
} = athenaPostingQueries;
